// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from '../../../form_exportacao_nfe/campos_nfe/selecao_todos_nfe';
import { Input } from '../../../../../../../common/input';

type CamposImpostoSeletivoProps = {
  component : React.ComponentType<*>,
}

export default function CamposImpostoSeletivo({ component } : CamposImpostoSeletivoProps) {
  const SelecaoTodos = component || SelecaoTodosNfe;

  return (
      <FormSection name="dadosImpostoSeletivo">
        <SelecaoTodos nomes={ ["dadosImpostoSeletivo"] } titulo="Informações do Imposto Seletivo (IS)"/>

        <div className="grupo-checkbox">
          <Input name="cstImpostoSeletivo" label="CST" checkbox/>
          <Input name="codClassTribImpostoSeletivo" label="Cód. Classificação Tributária" checkbox/>
          <Input name="valorBcImpostoSeletivo" label="Base Cálculo do IS" checkbox/>
          <Input name="aliquotaImpostoSeletivo" label="Alíquota" checkbox/>
          <Input name="aliquotaEspecificaImpostoSeletivo" label="Alíquota específica por un. medida" checkbox/>
          <Input name="unidadeImpostoSeletivo" label="Unidade de Medida Tributável" checkbox/>
          <Input name="quantidadeImpostoSeletivo" label="Quantidade Tributável" checkbox/>
          <Input name="valorIsImpostoSeletivo" label="Valor do IS" checkbox/>
        </div>
      </FormSection>
  );
}